import styled from 'styled-components';
import { Typography } from '@mui/material';

import colors from '../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 30px;
  height: calc(100% - 30px);
`;

const StatsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
`;

/**
 * A headline number.
 *
 * Three treatments rather than two. `$isAlert` is work in scope, which is what the lead came for.
 * `$isMuted` is the suspect tile: a number worth knowing — it is most of the backlog — but not one
 * to chase, so painting it like the others would undo the banding it exists to report.
 */
const StatCard = styled.div`
  flex: 1 1 140px;
  padding: 12px 16px;
  border: 1px solid ${({ $isAlert, $isMuted }) => {
    if ($isMuted) {
      return colors.shades.gamma13;
    }

    return $isAlert ? colors.shades.danger4 : colors.shades.secondary7;
  }};
  border-radius: 6px;
  background: ${({ $isAlert, $isMuted }) => {
    if ($isMuted) {
      return colors.shades.alpha1;
    }

    return $isAlert ? colors.shades.danger2 : colors.shades.secondary10;
  }};
`;

const StatValue = styled(Typography)`
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  color: ${({ $isMuted }) => ($isMuted ? colors.shades.gamma10 : 'inherit')};
`;

const StatLabel = styled(Typography)`
  font-size: 12px;
  color: ${colors.shades.gamma2};
`;

/** What the headline number is made of — the detail that stops it being read as the whole story. */
const StatSub = styled(Typography)`
  font-size: 11px;
  line-height: 16px;
  color: ${colors.shades.gamma2};
`;

/* Carries the toggle group's own `margin-left: auto`, so the pair sits at the end of the header. */
const ThresholdFilter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  margin-left: auto;
`;

const ThresholdRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ThresholdLabel = styled(Typography)`
  font-size: 12px;
  color: ${colors.shades.gamma2};
  white-space: nowrap;
`;

/**
 * Says which of the two numbers on this page is live and which is not.
 *
 * The past-due counts come from a scheduled server pass and the item ages are read from the items
 * themselves, so the page mixes two clocks. Without this the lead has no way to know that, and a
 * count that disagrees with what they find in the queue looks like a bug rather than a schedule.
 */
const FreshnessNote = styled(Typography)`
  font-size: 11px;
  color: ${colors.shades.gamma2};
  white-space: nowrap;
  cursor: default;
`;

export {
  Container,
  FreshnessNote,
  StatCard,
  StatLabel,
  StatSub,
  StatValue,
  StatsRow,
  ThresholdFilter,
  ThresholdLabel,
  ThresholdRow,
};
